import React from "react";

import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";

import TopLeftCorner from "../../shared-components/TopLeftCorner";
import TopRightCorner from "../../shared-components/TopRightCorner";
import BottomLeftCorner from "../../shared-components/BottomLeftCorner";
import BottomRightCorner from "../../shared-components/BottomRightCorner";

const NotFound = () => {
  return (
    <Grid container style={{ padding: "2.5rem", color: "#EEEEEE" }}>
      <Grid item>
        <TopLeftCorner color="#FF1919" />
        <Grid container alignItems="flex-end" style={{ height: "92.5%" }}>
          <BottomLeftCorner color="#FF1919" />
        </Grid>
      </Grid>

      <Grid item lg style={{ margin: "3rem 0" }}>
        <h1 className="not-found-title">
          #{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#FF1919",
              backgroundColor: "#EEEEEE",
            }}
          >
            Error
          </span>
        </h1>

        <h1 style={{ margin: "5rem 0 5rem" }} className="not-found-content">
          The page you're looking for{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#222831",
              backgroundColor: "#EEEEEE",
            }}
          >
            does not exist
          </span>{" "}
          :(
        </h1>

        <h1 className="not-found-content">
          Take me back to the{" "}
          <Link to="/">
            {" "}
            <span
              style={{
                borderBottom: "6px solid #FFC226",
                color: "#FFC226",
                paddingBottom: "0.6rem",
              }}
            >
              Home
            </span>
          </Link>{" "}
          page!
        </h1>
      </Grid>

      <Grid item>
        <TopRightCorner color="#FF1919" />
        <Grid container alignItems="flex-end" style={{ height: "92.5%" }}>
          <BottomRightCorner color="#FF1919" />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NotFound;
